var render = function render(){var _vm=this,_c=_vm._self._c;return _c('online-search-select',{staticClass:"w-100",attrs:{"searchFunction":_vm.onlineSearchCompanies,"labelProvider":_vm.labelProvider,"placeholder":"поиск компании","bg":"dark"},model:{value:(_vm.companyProxy),callback:function ($$v) {_vm.companyProxy=$$v},expression:"companyProxy"}})
}
var staticRenderFns = []

export { render, staticRenderFns }